import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-new-secondary-section',
  templateUrl: './new-secondary-section.component.html',
  styleUrls: ['./new-secondary-section.component.scss']
})
export class NewSecondarySectionComponent implements OnInit, OnChanges {

  listOfSecondarySections: any;
  sectionSuggestion1: any;
  subsectionSuggestion: any =[];
  allSubSections: any;
  sectionName: any;
  subSectionName:any;
  secondarySectionSuggestion: any = [];
  sectionSubsection : Map<String,Array<any>>;

  @Input()
  set secondarySectionData (listOfSecondarySections: any) {
    this.listOfSecondarySections = listOfSecondarySections ? listOfSecondarySections : [];
  }

  @Input()
  set listOfAllSubsections (subsectionList: any) {
    this.allSubSections = subsectionList ? cloneDeep(subsectionList) : [];
  }

  @Input() 
  set sectionSuggestionList(sectionList: any){
    this.sectionSuggestion1 = cloneDeep(sectionList);
  }

  @Input()
  set section (section: any) {
    this.sectionName = section ? section : '';
  }

  @Input()
  set subSection(subSection:any){
    this.subSectionName = subSection?subSection:'';
  }
  @Input() storyEditMode : boolean;

  @Output() secondarySectionChanged: EventEmitter<number> = new EventEmitter();

  @Input() subSectionsId: any[];

  constructor() { }

  ngOnChanges(changes: SimpleChanges){
  }

  ngOnInit() { 
    this.excludeSecondarySections();
  }

  addNewSection() {
    this.listOfSecondarySections.push(
      {
        "section":"",
        "subSection":""
      }
    )
  }
  deleteSection(addedSection: any, i : number) {
    this.listOfSecondarySections.splice(this.listOfSecondarySections.indexOf(addedSection),1);
    this.subSectionsId.splice(i,1);
    this.excludeSecondarySections();
  }


  sectionChangedHandler(ev)
  {
    this.excludeSecondarySections();
  }

  excludeSecondarySections()
  {
    this.sectionSubsection = new Map<String,Array<any>>();
    this.listOfSecondarySections.forEach(element => {
      if(element.subSection != '' && element.section != '')
      {
        if(this.sectionSubsection.has(element.section))
        {
          this.sectionSubsection.get(element.section).push(element.subSection);
        }else{
          let subSectionList = [];
          subSectionList.push(element.subSection);
          this.sectionSubsection.set(element.section,subSectionList);
        }
      }
    });
  }

}
